export default {
  name: 'InputRadioImage',
  props: ['field', 'value', 'size'],
  data: function data() {
    return {
      model: this.value,
      boxSize: this.size || 120
    };
  },
  watch: {
    model: function model(value) {
      this.$emit('input', value);
    }
  }
};